import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CardEncoderSettingService } from 'src/app/services/card-encoder-setting-service/card-encoder-setting.service';
import { EditDataServiceService } from 'src/app/services/editDataService/edit-data-service.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { FiltersModel } from 'src/app/shared/models/FiltersModel.model';
import { PublicCardEncoderSettingModel } from 'src/app/shared/models/public-card-encoder-setting-model';

@Component({
  selector: 'app-card-encoders',
  templateUrl: './card-encoders.component.html',
  styleUrls: ['./card-encoders.component.scss']
})
export class CardEncodersComponent {
  displayedColumns: string[] = ['select', 'id', 'cardEncodeType'];
  dataSource: MatTableDataSource<PublicCardEncoderSettingModel>;
  editMode: boolean = false;
  numSelected: number;
  rowCount: number;
  columnList: string[];
  hasCardEncoderSettings: boolean;
  filters: FiltersModel = {
    ColumnsToSearch: [],
    CurrentPage: 0,
    PageSize: 10,
    OrderColumn: null,
    OrderType: null,
    SearchText: null,
    FilterTags: []
  };

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private cardEncoderSettingService: CardEncoderSettingService,
    private loadingService: LoadingService, private editDataServiceService: EditDataServiceService,
    private cdRef: ChangeDetectorRef, private snackBar: MatSnackBar) {

    const $this = this;

    $this.loadingService.toggle("");

    $this.cardEncoderSettingService.GetAllColumnNames().subscribe(resp => {
      $this.columnList = resp;
    });

    $this.refreshList(true);
  }

  selection = new SelectionModel<any>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const $this = this;
    if ($this.dataSource == null || $this.dataSource == undefined) {
      return false;
    } else {
      $this.numSelected = $this.selection.selected.length;
      const numRows = $this.dataSource.data.length;
      return $this.numSelected === numRows;
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  ngAfterViewChecked() {
    const $this = this;
    $this.cdRef.detectChanges();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  addNew() {
    const $this = this;
    $this.router.navigate(["backoffice/card-encoders/cardencoder-form"]);
  }

  delete() {
    const $this = this;
    const selectedIds = $this.selection.selected.map(({ id }) => id);
    $this.loadingService.toggle("");
    $this.cardEncoderSettingService.DeleteListOfCardEncoderSetting(selectedIds).subscribe(() => {
      $this.refreshList();
    });
  }

  edit() {
    const $this = this;
    $this.editDataServiceService.cardEncoderSettingIdToEdit = $this.selection.selected[0]['id'];
    $this.router.navigate(["backoffice/card-encoders/cardencoder-form"]);
  }

  search() {
    const $this = this;
    $this.loadingService.toggle("");
    $this.refreshList();
  }

  refreshList(updateHasPmsSettings: boolean = false) {
    const $this = this;

    if ($this.paginator != null) {
      $this.filters.PageSize = $this.paginator.pageSize;
      $this.filters.CurrentPage = $this.paginator.pageIndex;
    }

    $this.selection = new SelectionModel<any>(true, []);
    $this.numSelected = 0;
    $this.cardEncoderSettingService.GetAllCardEncoderSettings($this.filters).subscribe(resp => {
      if (resp != null) {
        $this.rowCount = resp.cardEncoderSettings.length;
        $this.dataSource = new MatTableDataSource(resp.cardEncoderSettings);
        if (updateHasPmsSettings) {
          $this.hasCardEncoderSettings = resp.cardEncoderSettings.length > 0;
        }
        $this.dataSource.paginator = $this.paginator;
        $this.dataSource.sort = $this.sort;
        $this.loadingService.toggle("");
      }
    });
  }
}
